if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"website","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(39[58]|[06]53|09|189|245|847|855)|2(6(1|2|35|83|93)|[35]51|(58|70|84|97)9|053|095|370|465)|3(9(01|33|45)|(44|5|78)7|119|131|768)|4(305|310|6|763|789|914|965)|5(5(17|31|66)|6(19|55|77)|045|201|331|957)|7(5(48|49|71)|307|655|751|763|801|957)|8((02|62|87)5|(43|54|9)9|151|487|742)|9(155|32|659|89|997)|6264|6361)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}